import gql from 'graphql-tag'

export const DELETE = gql`
  mutation person_delete($id: ID!) {
    personDelete(id: $id) {
      id
    }
  }
`
